import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Button, Divider, FormGroup, withStyles } from '@material-ui/core';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import AccountCircle from '@material-ui/icons/AccountCircle';
import LockIcon from '@material-ui/icons/Lock';
import MailIcon from '@material-ui/icons/Mail';
import { useHistory } from 'react-router-dom'
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { FaGoogle, FaLinkedin } from 'react-icons/fa'
import { useSelector,useDispatch } from 'react-redux';
import { LinkedIn } from 'react-linkedin-login-oauth2';
import linkedin from 'react-linkedin-login-oauth2/assets/linkedin.png'
import { GoogleLogin } from 'react-google-login';
import { addProfile, userSignIn } from '../../../redux/actions/index';
import { Phone } from "@material-ui/icons";
import Sign from './Sign';
import '../Auth.css'
import Swal from 'sweetalert2';


const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width:'100vw',
    height:'100vh'
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "7px",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function Signup({ btn }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const reduxState = useSelector(state => state)
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // For hanlding the remember user.
  const [state, setState] = React.useState({
    checkedMe: true,
    checkedB: true,
    checkedF: true,
    checkedG: true,
  });

  // default empty values of the input fields
  const [form, setForm] = useState({
    name: "",
    username: "",
    password: "",
    password2: "",
  });

  // enter the input key in the field.
  const updateField = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const successResponseGoogle = (response) => {
    console.log(response)
    fetch('https://recruitingmonk-v2.azurewebsites.net/auth/google',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({tokenId:response.tokenId})
    }).then(res => res.json(res))
    .then(res => {
      console.log(res);
      if(res.success){
        localStorage.setItem("token", res.token);
        
        //assigning the new value to the state
        dispatch(userSignIn(res.token));
        dispatch(addProfile(res.user));
      }
      handleClose();
    }).catch(error => {
      handleClose();
      console.log(error)
    })
  }

  const failureResponseGoogle = (response) => {
    console.log("Google login failed",response)
  }

  const successResponseLinkedin = (data) => {
    console.log(data.code)
    let code = data.code;
    fetch('https://recruitingmonk-v2.azurewebsites.net/auth/linkedin',{
      method:'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body:JSON.stringify({code})
    }).then(res => res.json())
    .then(res => {
        console.log(res)
        if(res.success){
          localStorage.setItem("token", res.token);
          
          //assigning the new value to the state
          dispatch(userSignIn(res.token));
          dispatch(addProfile(res.user));
        }
        handleClose();
    })
    .catch(err => {
        handleClose();
        console.log(err)
    })
  }

  const failureResponseLinkedin = (error) => {
    console.log(error)
  }

  // step for transferring the data.
  const finalStep = (e) => {
    e.preventDefault();

    const allData = {
      username: form.username,
      password: form.password,
      password2: form.password2,
      name: form.name,
      phone: form.phone,
    };

    userRegister(allData)
      .then(() => {
        console.log(allData)
        console.log("user has registered");
        history.push("/");
      })
      .catch((err) => console.log(err));
  };

  //Main logic of signing up.
  const userRegister = newUser => {
    var raw = JSON.stringify({
      "username": newUser.username,
      "password": newUser.password,
      "password2": newUser.password2,
      "name": newUser.name,
      "phone":newUser.phone,
      "ip":reduxState.info.info.ip,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    return fetch("https://recruitingmonk-app.azurewebsites.net/register", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);

        // creating red alert to the user from their consequences.
          if (result.uid) {
            // If successfully registered.
            document.getElementById('conseq').style.color = "green"
                  document.getElementById('conseq').innerHTML = "Thanks for registering. Now you can Sign in."
          } else if(result.username){
           //user already exists
           document.getElementById("conseq").style.color = "red";
            document.getElementById("conseq").innerHTML = "User already Exists!"; 
          }
          else {
            // if any issue in signup.
            document.getElementById("conseq").style.color = "red";
            document.getElementById("conseq").innerHTML = "Unable to register User!";
          }
      })
      .catch((error) => Swal.fire({
        icon:'error',
        title:'Unable to register User!',
        text:`${error}`
      }));
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  //   const doSignUp =()=>{
  //     document.getElementById('siginModalId').style.display = 'none';
  // }

  return (
    <div>
      <Button
        className=""
        style={{
          color: btn ? "#fff" : "#B0343C",
          backgroundColor: btn ? "#B0343C" : "",
          fontWeight: "bold",
        }}
        variant={btn ? "contained" : "text"}
        onClick={handleOpen}
      >
        Sign Up
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade
          in={open}
          className="signinModal glass-6 flex flex-col items-center p-4 w-5/6 md:w-1/4"
          id="siginModalId"
        >
          <div className="px-6" style={{
              backgroundColor: "#eccdb2",
              borderRadius: "5px",
            }}>
            <div
              className="flex flex-col items-center gap-4 w-full"
              id="transition-modal-title"
            >
              <GoogleLogin
              clientId="184778796786-pd8mft6j3nkk5a2mnb78r8jjem2ot0q5.apps.googleusercontent.com"
              buttonText="Sign in with Google"
              onSuccess={successResponseGoogle}
              onFailure={failureResponseGoogle}
              cookiePolicy={'single_host_origin'}
              className="google_btn"
            />
              <div style={{width:'100%'}}>
                <LinkedIn
                  clientId="78q6ffsfov0zok"
                  scope="r_liteprofile r_emailaddress"
                  onFailure={failureResponseLinkedin}
                  onSuccess={successResponseLinkedin}
                  redirectUri="https://recruitingmonk-app.azurewebsites.net/linkedin"
                  renderElement={({ onClick, disabled }) => (
                  <button onClick={onClick} disabled={disabled} style={{padding:'0px',border:'none',width:'100%'}}>
                    <Button id="transition-modal-description" variant="contained" style={{backgroundColor:'#0274b3',color:'#fff',width:'100%',margin:'0px',height:'2.4rem',textTransform:'capitalize'}} startIcon={<FaLinkedin />}>Sign in with <p style={{ fontWeight: 'bold' }}>&nbsp;LinkedIn</p></Button>
                  </button>
                  )}
                >
                <img src={linkedin} alt="Log in with Linked In" style={{ maxWidth: '180px' }} />
                </LinkedIn>
              </div>
            </div>

            <div class="my-2">or use</div>

            <form
              method="POST"
              onSubmit={finalStep}
              className="flex flex-col items-center w-full"
            >
              <div className="flex flex-col items-center w-full mb-4">
                <div className="flex flex-row items-center w-full my-2">
                  <AccountCircle className="text-white self-end mr-3" />
                  <TextField
                    id="input-with-icon-grid"
                    fullWidth
                    label="name"
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={updateField}
                    required
                  />
                </div>
                <div className="flex flex-row items-center w-full my-2">
                  <MailIcon className="text-white self-end mr-3" />
                  <TextField
                    id="input-with-icon-grid"
                    fullWidth
                    label="Email"
                    name="username"
                    value={form.username}
                    onChange={updateField}
                    type="email"
                    required={true}
                  />
                </div>
                <div className="flex flex-row items-center w-full my-2">
                  <Phone className="text-white self-end mr-3" />
                  <TextField
                    id="input-with-icon-grid"
                    fullWidth
                    label="Phone Number"
                    name="phone"
                    onChange={updateField}
                    value={form.phone}
                  />
                </div>
                <div className="flex flex-row items-center w-full my-2">
                  <LockIcon className="text-white self-end mr-3" />
                  <TextField
                    id="input-with-icon-grid"
                    fullWidth
                    label="Password"
                    name="password"
                    value={form.password}
                    onChange={updateField}
                    type="password"
                    required
                  />
                </div>
                <div className="flex flex-row items-center w-full my-2">
                  <LockIcon className="text-white self-end mr-3" />
                  <TextField
                    id="input-with-icon-grid"
                    fullWidth
                    label="Confirm Password"
                    name="password2"
                    onChange={updateField}
                    value={form.password2}
                    type="password"
                    required
                  />
                </div>
              </div>
              <div className="conseq">
                <p id="conseq"></p>
              </div>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                container
                style={{ backgroundColor: "#B0343C", color: "#fff" }}
              >
                Signup
              </Button>
            </form>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
